import { ChangeEvent } from 'react';
import {
  Checkbox,
  Divider,
  Heading,
  SimpleGrid,
  Text,
  VStack,
} from '@chakra-ui/react';

import { usePageTextContent } from 'context/pageTextContent';

interface Props {
  categories: Category[];
  onChange(categoryId: string): void;
  isChecked(categoryId: string): boolean;
}

export const CategoriesSection = (props: Props) => {
  const { categories, onChange, isChecked } = props;

  const { content } = usePageTextContent<SearchPageContent>();

  const { categories: categoriesContent } = content;

  const onCategoryChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <VStack
      pb="1.75rem"
      px="2.5rem"
      spacing="0.875rem"
      align="flex-start"
      w="full"
    >
      <Heading fontSize="1.5rem">{categoriesContent}</Heading>

      {categories.map(category => (
        <VStack key={category.id} align="flex-start" w="full">
          <Text>{category.name}</Text>

          <SimpleGrid
            columns={[2, 2, 3]}
            columnGap="2rem"
            rowGap="0.5rem"
            w="full"
          >
            {category.children.map(subcategory => (
              <Checkbox
                key={subcategory.id}
                size="lg"
                variant="zmyle"
                value={subcategory.id}
                onChange={onCategoryChange}
                isChecked={isChecked(subcategory.id)}
              >
                <Text fontSize="0.875rem">{subcategory.name}</Text>
              </Checkbox>
            ))}
          </SimpleGrid>

          <Divider mt="1rem" />
        </VStack>
      ))}
    </VStack>
  );
};
